import FormColor from './form/FormColor'
import api from '../../utils/api'
import { useState, useEffect } from 'react'
/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'

function EditColor({ id, btCancelAction, handleOnSuccess }) {
    const [color, setColor] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    useEffect(() => {

        api.get(`/color/get/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            if (response) {
                setColor(response.data.color)
            }

        })
    }, [token, id])

    async function updateColor(obj) {
        let msgType = 'success'
        const data = await api.patch(`/color/update/${id}`, obj, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            }
        }).then((response) => {
            return response.data
        })
            .catch((err) => {
                msgType = 'error'
                return err.response.data
            })

        setFlashMessage(data.message, msgType)

        if (msgType !== 'error') {

            handleOnSuccess()
        }
    }


    return (
        color.name && (
            <FormColor title="Editar Cor" btnText="Salvar" handleSubmit={updateColor} colorData={color} costData={color.cost} btCancelAction={btCancelAction} />
        )
    )
}

export default EditColor